/* src/app/order/components/standard-selection/standard-button.style.scss */
button {
  display: flex;
}
button.selected {
  justify-content: flex-start !important;
  padding-left: 15px !important;
  padding-right: 10px !important;
  min-width: 128px !important;
  min-height: 48px !important;
}
button:not(.selected) {
  min-width: 106px !important;
  min-height: 48px !important;
}
button nb-icon {
  color: #ffffff;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  button:not(.selected) {
    padding-top: 15px !important;
  }
  button.selected {
    padding-top: 11px !important;
  }
}
@media screen and (max-width: 600px) {
  button:not(.selected),
  button.selected {
    max-width: 260px !important;
  }
}
/*# sourceMappingURL=standard-button.style.css.map */
